// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/theme/semantic.less
// module id = 477
// module chunks = 0